import $ from "jquery";
import baseClass from "../base/base";

import AOS from "aos";

baseClass.OnLoadArrAdd(function () {
  AOS.init();
});
